module.exports = __webpack_public_path__ + "static/media/GreatSouthernHerald-devicecomp-min.a65915d7.webp";